/**
 * Función que devuelve el texto asociado a un estado de un OS
 * 
 * @param {*} estadoId - Identificador del estado
 * @returns El texto asociado al estado
 */
export const renderEstadoTexto = (estadoId) => {
    switch (estadoId) {
        case 1: return 'Borrador';
        case 2: return 'Enviado a aprobar';
        case 3: return 'Aprobado';
        case 4: return 'Cancelado';
        case 5: return 'Completado';
        default: return 'Sin Estado';
    }
};

/**
 * Función que devuelve el icono asociado a un estado de un OS
 * @param {*} obj - Objeto con el estado
 * @param {*} field - Campo del objeto con el estado
 * @param {*} valor - Valor del campo del objeto con el estado
 * @returns El icono asociado al estado
 */
export const checkField = (obj, field, valor) => {
    return obj?.[field] === valor;
}

// Correo de notificación
export const CORREO_DIRECTOR = "mbellini@unsj.edu.ar";